import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  public static http: HttpClient;

  constructor() { }

  public static loadScript(src: string) {
    let script = document.createElement('script');
    script.src = src;
    script.async = false;
    script.defer = true;
    document.body.appendChild(script);
  }

  /**
   * Function to call service
   * @param  {any} options - Options to call service
   * options = {
        method: 'GET | POST'
        path: 'service_path',
        parameters: `parameter_of_service`,
        onSuccess: (response: any) => {
            // Success callback function
        },
        onFailure: (error: any) => {
            // Error callback function
        }
    };
   *  @returns {void} - Invoke callback functions
   */
  public static callService(options: any): void {
    if (options.method === 'GET') {
      CommonService.http
        .get(options.path, { params: options.parameters })
        .subscribe(
          (response: any) => {
            console.log(
              `Service path: ${options.path}, response: `,
              response
            );
            options.onSuccess(response);
          },
          (error) => {
            console.error(error);
            options.onFailure(error);
          }
        );
    } else if (options.method === 'POST') {
      CommonService.http.post(options.path, options.parameters).subscribe(
        (response: any) => {
          console.log(
            `Service path: ${options.path}, response: `,
            response
          );
          options.onSuccess(response);
        },
        (error) => {
          console.error(error);
          options.onFailure(error);
        }
      );
    }
  }
}
